import { Navigate, useSearchParams } from 'react-router-dom'

// Route bridge: legacy /payments/new deep-links now open the payment-create
// drawer on top of the payments list instead of rendering a standalone page.
export default function PaymentFormPage() {
  const [searchParams] = useSearchParams()
  const next = new URLSearchParams()

  next.set('panel', 'create')

  const clientId = searchParams.get('client_id')
  if (clientId) next.set('create_client_id', clientId)

  const jobId = searchParams.get('job_id')
  if (jobId) next.set('create_job_id', jobId)

  const invoiceId = searchParams.get('invoice_id')
  if (invoiceId) next.set('create_invoice_id', invoiceId)

  const amount = searchParams.get('amount')
  if (amount) next.set('create_amount', amount)

  const reportJob = searchParams.get('report_job')
  if (reportJob) next.set('report_job', reportJob)

  return <Navigate to={`/payments?${next.toString()}`} replace />
}
